import { render, staticRenderFns } from "./SortGroupListHeader.vue?vue&type=template&id=0951e2e2"
import script from "./SortGroupListHeader.vue?vue&type=script&lang=ts"
export * from "./SortGroupListHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports